import { list } from './list';
export { type EmailTemplateStatsListQuery } from './list';

export const emailTemplatesStats = {
  list,
};
